<script setup lang="ts">
import { TESwitch, TESwitchLabel, TETextInput } from '@ben/vite-te'

import type { InertiaForm } from '@inertiajs/vue3'

const props = defineProps<{
  data: { key: string; label: string; type?: string; options?: string[]; required?: boolean }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: InertiaForm<Record<string, any>>
}>()

const model = computed({
  get: () => {
    if (props.data.key.includes('.')) {
      const [first, second] = props.data.key.split('.')
      if (first && second) {
        return props.form[first][second]
      }
    }
    return props.form[props.data.key]
  },
  set: (val) => {
    if (props.data.key.includes('.')) {
      const [first, second] = props.data.key.split('.')
      if (first && second) {
        // eslint-disable-next-line vue/no-mutating-props
        props.form[first][second] = val
      }
    } else {
      // eslint-disable-next-line vue/no-mutating-props
      props.form[props.data.key] = val
    }
  },
})
</script>

<template>
  <template v-if="data.type === 'checkbox'">
    <TESwitchLabel :title="data.label">
      <TESwitch v-model="model" :name="data.key" />
    </TESwitchLabel>
  </template>

  <TETopLabelLayout
    v-else
    :name="data.key"
    :title="data.label"
    :error="form.errors[data.key]"
    :required="data.required ?? false"
  >
    <!--    {{data.key}} -->
    <select
      v-if="data.type === 'select' || data.type === 'multiselect'"
      v-model="model"
      :multiple="data.type === 'multiselect'"
      :name="data.key"
      class="dark:ring-primary-600 dark:focus:border-primary-600 dark:focus:ring-primary-600 block w-full appearance-none rounded-sm border border-gray-300 bg-white px-4 py-2 pr-8 leading-tight text-gray-700 focus:border-blue-500 focus:bg-white focus:outline-hidden dark:border-gray-500 dark:bg-zinc-800 dark:text-white dark:ring-offset-gray-700 dark:focus:bg-zinc-800 dark:focus:ring-offset-gray-700"
    >
      <option hidden="" value="">Bitte auswählen</option>

      <option v-for="option in props.data.options" :key="option">
        {{ option }}
      </option>
    </select>

    <TETextInput
      v-else-if="data.type !== 'textarea'"
      v-model="model"
      :name="data.key"
      :type="data.type ?? 'text'"
    />

    <textarea
      v-else
      v-model="model"
      class="focus:ring-opacity-50 dark:ring-primary-600 dark:focus:border-primary-600 dark:focus:ring-primary-600 w-full rounded-sm border-gray-300 shadow-xs focus:border-indigo-300 focus:bg-white focus:ring-3 focus:ring-indigo-200 focus:outline-hidden dark:border-gray-500 dark:bg-zinc-800 dark:text-white dark:ring-offset-gray-700 dark:focus:bg-zinc-800 dark:focus:ring-offset-gray-700"
      :name="data.key"
      rows="4"
    />
  </TETopLabelLayout>
</template>
